// <ConfirmDialog> — our OWN styled confirmation modal (#confirm), replacing the native
// window.confirm() so exit/destructive prompts match the game's visual style (unified look).
// Opened by the classic showConfirm({title,msg,okText,cancelText,danger,onOk}) which stashes the
// display fields on app.confirm and the callback on app.confirmAction; the confirm-yes / confirm-no
// actions run the callback / close. Same .overlay/.sheet scaffold + data-action attrs as the other
// overlays so document-level click delegation handles it. PURE function of `app`.
import { html, t } from '../shared.js';

export function ConfirmDialog({ app }: { app: AppState }) {
  const c = app.confirm;
  if (!c) return '';
  return html`
    <div class="overlay confirm-overlay"><div class="sheet confirm-sheet">
      <div class="confirm-title">${c.title || t('confirm.title')}</div>
      ${c.msg ? html`<div class="confirm-msg">${c.msg}</div>` : ''}
      ${c.input ? html`<input id="confirmInput" class="confirm-input" maxlength=${c.input.maxLength || 40} placeholder=${c.input.placeholder || ''} value=${c.input.value || ''} autofocus autocomplete="nickname" />` : ''}
      <div class="row confirm-actions">
        <button class="ghost" data-action="confirm-no">${c.cancelText || t('confirm.cancel')}</button>
        <button class=${c.danger ? 'red' : 'yellow'} data-action="confirm-yes">${c.okText || t('confirm.ok')}</button>
      </div>
    </div></div>
  `;
}
